export const checkoutAddress = {
  shippingAddress: "Adresse de livraison",
  selectYourDeliveryAddress: "Sélectionnez votre adresse de livraison",
  defaultDeliveryAddress: "Adresse de livraison par défaut",
  verifyYourAddress: 'Vérifiez votre adresse',
  ensureAccuracySuggestChange: "Pour assurer l'exactitude de la livraison, nous vous suggérons le changement ci-dessous.",
  chooseAddressToUse: "Veuillez choisir l'adresse que vous souhaitez utiliser :",
  suggestedAddress: 'Adresse suggérée',
  enteredAddress: 'Adresse saisie',
  addNewAddress: 'Ajouter une nouvelle adresse',
  shipToThisAddress: 'Expédier à cette adresse',
  editAddress: "Modifier l'adresse",
  saveAddress: "Sauvegarder l'adresse",
  backToCart: 'Retour au panier',
  deliveryAddressSelected: 'Adresse de livraison sélectionnée',
};
export const checkoutReview = {
  review: 'Révision',
  orderItems: 'Articles de la commande',
  autoReplenishOrder: 'Commande de réapprovisionnement automatique',
  confirmThatRead: "Je confirme avoir lu et accepté les",
  sloanConfirmThatRead: "En passant la commande, je confirme avoir lu et accepté les",
  placeOrder: 'Passer la commande',
  scheduleReplenishmentOrder: 'Planifier une commande de réapprovisionnement',
  orderType_PLACE_ORDER: 'Aucune (commande unique seulement)',
  orderType_SCHEDULE_REPLENISHMENT_ORDER: 'Commande de réapprovisionnement',
  termsAndConditions: 'Modalités et conditions',
  editShippingAddress: "Modifier l'adresse de livraison",
  poNumber: 'Numéro de bon de commande',
  every: 'Chaque',
  startOn: 'Débuter le',
  dayOfMonth: 'Le jour du mois',
  repeatOnDays: 'Répéter les jours suivants',
  recurrencePeriodType_DAILY: 'Jour(s)',
  recurrencePeriodType_WEEKLY: 'Semaine(s)',
  recurrencePeriodType_MONTHLY: 'Mois',
  confirmationEmail: 'Envoyer un courriel de confirmation à',
  enterConfirmationEmail: 'Entrez le courriel de confirmation',
};
export const checkoutShipping = {
  shippingMethod: "Mode de livraison",
  standardDelivery: 'Livraison standard',
  premiumDelivery: 'Livraison prioritaire',
  accountNumberMandatory: "Le numéro de compte est obligatoire pour le mode de livraison sélectionné.",
  shippingNotes: "Notes de livraison",
  shippingDetail: "Détails de livraison",
  shippingAccountNumber: 'Numéro de compte de perception',
  collectNumberFedexError: "Doit comporter jusqu'à 9 caractères alphanumériques.",
  collectNumberDefaultError: "Doit comporter jusqu'à 6 caractères alphanumériques.",
};
export const checkoutType = {
  backToCart: 'Retour au panier',
  invalid: {
    accountType: 'Votre compte ne vous permet pas de passer des commandes ici.',
  },
};
export const checkoutPO = {
  noPoNumber: 'S.O.',
  poNumber: 'Numéro de bon de commande (facultatif)',
  costCenter: 'Centre de coûts',
  placeholder: 'Saisir le B.C.',
  availableLabel: "Les adresses de livraison disponibles dépendent de l'unité du centre de coûts",
};
export const checkoutProgress = {
  methodOfPayment: 'Mode de paiement',
  deliveryMode: 'Mode de livraison',
  paymentDetails: 'Détails du paiement',
  reviewOrder: 'Réviser la commande',
  deliveryAddress: "Adresse de livraison",
};
export const checkoutMode = {
  deliveryMethod: 'Mode de livraison',
  standardDelivery: 'Livraison standard',
  premiumDelivery: 'Livraison prioritaire',
};
export const orderCost = {
  orderSummary: 'Sommaire de la commande',
  subtotal: 'Sous-total après rabais :',
  shipping: 'Livraison :',
  estimatedShipping: 'Livraison estimée :',
  discount: 'Vous avez économisé :',
  salesTax: 'Taxes de vente :',
  grossTax: "Le total de la commande n'inclut pas la taxe de",
  grossIncludeTax: 'Le total de la commande inclut la taxe de',
  total: 'Total :',
  toBeDetermined: 'À déterminer',
};

export const checkout = {
  checkoutAddress,
  checkoutReview,
  checkoutShipping,
  checkoutType,
  checkoutPO,
  checkoutProgress,
  checkoutMode,
  orderCost,
};
